import { User } from '@domain'

import api from '.'
import { UpdatePrefsReq, UpdateUserReq, UsersListReq } from './users.types'

// Query Key factory
export const UsersKey = {
	all: ['users'],
	list: (query: UsersListReq) => [...UsersKey.all, query],
	me: ['me'],
}

const UsersApi = {
	list: (query: UsersListReq) =>
		api.get<APIRes<User[]>>('/users', { params: query }).then((res) => res.data.data),
	me: () => api.get<APIRes<User>>('/me').then((res) => res.data.data),
	addUser: (query: { email: string; roleIds: string[] }) => api.post('/users', query),
	editUser: ({ id, enabled, roleIds }: UpdateUserReq) =>
		api.patch(`/users/${id}`, { enabled, roleIds }),
	sendInvite: (userId: Id) => api.post(`/users/${userId}/send-invite`),
	enable: (userId: Id) => api.put(`/users/${userId}/enable`),
	disable: (userId: Id) => api.delete(`/users/${userId}`),
	updatePreferences: (req: UpdatePrefsReq) => api.patch('/me/user-preferences', req),
}

export default UsersApi
